import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import useWindowDimensions from "../hooks/useWindowDimensions";
const CourseSummary = () => {
  const { window_height, window_width } = useWindowDimensions();
  const [isHeightLimit, setIsHeightLimit] = useState(false);
  useEffect(() => {
    // effect
    if (window_height < 600) {
      setIsHeightLimit(true);
    }
  }, [window_height]);
  const [courseToShow, setCourseToShow] = useState(0);
  const courseArray_2022 = [
    [
      0,
      "하프코스",
      {
        title: "하프코스(21.0975km)",
        content: <HalfCourse />,
        time: "2022.10.16.10시 출발 (9시 집합)",
        course: "21.0975km(대청공원→에코공원→송강식당→대청공원)",
        number: "접수 선착순 3,000명(지역제한 없음)",
        // additional: "(대전・세종・충남・충북 거주자에 한함)",
        courseAttr: "기존의 자전거도로와 산책로를 주로로 활용, 교통통제 최소화",
        attrAdditional: "",
        link: "/course/#half",
        img_link: "/2024_half.jpeg",
        color: "#2d75d1",
        noneColor: "#2798D4",
      },
    ],
    [
      1,
      "미니코스",
      {
        title: "미니코스(10km)",
        content: <MiniCourse />,
        time: "2022.10.16. 10시 10분 출발(9시 집합)",
        course: "10km(대청공원↔에코공원)",
        number: "접수 선착순 3,000명(지역제한 없음)",
        courseAttr:
          "대한민국 관광 100선중의 하나인 계족산 황톳길이 포함된 주로로써 가을의 정취를 만끽 할 수 있는 코스",
        attrAdditional:
          "산디마을에서 임도3거리까지 거리 2.5km가 오르막(내리막), ",
        link: "/course/#mini",
        img_link: "/2024_mini.jpeg",
        color: "#8A0B83",
        noneColor: "#B00EA7",
      },
    ],
    [
      2,
      "건강코스",
      {
        title: "건강코스(5km)",
        content: <HealthCourse />,
        time: "2022.10.16. 10시 10분 출발(8시 30분 집합)",
        course: "10km(대청공원↔에코공원)",
        number: "접수 선착순 3,000명(지역제한 없음)",
        courseAttr:
          "대한민국 관광 100선중의 하나인 계족산 황톳길이 포함된 주로로써 가을의 정취를 만끽 할 수 있는 코스",
        attrAdditional:
          "산디마을에서 임도3거리까지 거리 2.5km가 오르막(내리막), ",
        link: "/course/#health",
        img_link: "/2024_health.jpeg",
        color: "#39979e",
        noneColor: "#47BBC4",
      },
    ],
  ];

  return (
    <Container
      className="text-center container mb-5"
      style={{ marginTop: "5rem", padding: 0 }}
      id="courseSummary"
    >
      <h2>코스 안내</h2>
      <Row className="mt-3 d-none d-lg-flex" style={{ color: "#A0A0A0" }}>
        {courseArray_2022.map(([courseIndex, courseName, courseInfo], key) => {
          return (
            <Col
              key={key}
              onClick={() => {
                setCourseToShow(courseIndex);
              }}
              style={{
                cursor: "pointer",
                height: "3rem",
                lineHeight: "3rem",
                fontSize: "1.1rem",
                backgroundColor: `${
                  courseToShow === courseIndex
                    ? courseInfo.color
                    : courseInfo.noneColor
                }`,
                // color: `${courseToShow === courseIndex ? 'white' : ''}`,
                color: "white",
                fontWeight: `${courseToShow === courseIndex ? "bold" : ""}`,
              }}
            >
              {courseName}
            </Col>
          );
        })}
      </Row>
      <Row>
        {/* 이미지 */}
        <Container style={{ padding: 0 }} className="position-relative">
          <img
            src={`${courseArray_2022[courseToShow][2].img_link}`}
            alt="online_marathon"
            style={{ maxWidth: "100%" }}
          />
          {/* mobile에서 화살표 */}
          <i
            className="fas fa-chevron-left fa-3x cursor-pointer text-white d-inline-block d-lg-none position-absolute top-50"
            style={{ left: "1rem" }}
            onClick={() => {
              if (courseToShow !== 0) {
                setCourseToShow(courseToShow - 1);
              } else {
                setCourseToShow(6);
              }
            }}
          ></i>
          <i
            className="fas fa-chevron-right fa-3x cursor-pointer text-white d-inline-block d-lg-none position-absolute top-50"
            style={{ right: "1rem" }}
            onClick={() => {
              if (courseToShow !== 6) {
                setCourseToShow(courseToShow + 1);
              } else {
                setCourseToShow(0);
              }
            }}
          ></i>
        </Container>
        {/* 간단한 코스 설명 */}
        <div
          className="text-start"
          style={{
            paddingLeft: "1rem",
            borderLeft: "4px solid #2d75d1",
            background: "rgba(0,0,0,0.3)",
            color: "white",
          }}
        >
          {courseArray_2022[courseToShow][2].content}
          <div className="ms-4 bg-custom-color rounded-pill d-inline-block p-1 ps-3 pe-3 mb-2 ms-2">
            <a
              style={{ color: "white" }}
              href={courseArray_2022[courseToShow][2].link}
            >
              자세히 보기
            </a>
          </div>
        </div>
        {/* <div
          style={{
            height: `${isHeightLimit ? '100%' : '60vh'}`,
            width: '100%',
            backgroundImage: `url(${courseArray[courseToShow][2].img_link})`,
            backgroundSize: 'cover',
            padding: '0',
          }}
        > */}

        {/* </div> */}
      </Row>
    </Container>
  );
};
export default CourseSummary;


const HalfCourse = () => {
  return (
    <div>
      <h5 className="p-2">하프 코스(21.0975km)</h5>
      <p className="ms-4">대회일시: 2025.10.19.(일) 09:00 (집결 08:30)</p>
      <p className="ms-4">
        대회코스: 하프코스(대청공원→에코공원→송강식당→대청공원)
      </p>
      <p className="ms-4">
        코스 특징: 아름다운 자연경관과 깨끗한 주변환경을 자랑하는 금강과
        대청호를 연결하는 코스로
      </p>
      <p className="ms-5 ps-5">
        1차 반환점을 돌아 6.0km 지점에서 시작되는 600여 미터의 고갯길이 가장
        어려운 코스지만,
      </p>
      <p className="ms-5 ps-5">
        고갯마루에 올라서면 대청호의 탁 트인 전경과 오색의 가로수를 곁에 두고
        완만한
      </p>
      <p className="ms-5 ps-5">
        오르내림을 반복, 달림이 여러분의 오감을 열어주는 대청호 마라톤의 색다른
        맛에 취하게 됩니다.
      </p>
    </div>
  );
};
const MiniCourse = () => {
  return (
    <div>
      <h5 className="p-2">미니코스(10km)</h5>
      <p className="ms-4">대회일시: 2025.10.19.(일) 09:15 (집결 08:30)</p>
      <p className="ms-4">대회코스: 대청공원 ↔ 에코공원</p>
      <p className="ms-4">
        코스 특징: 대청호마라톤대회의 중추적인 코스로 대청호 자연의 아룸다움을
        맘껏 만끽하며 달릴 수 있는
      </p>
      <p className="ms-5 ps-5">
        왕복형 코스입니다. 대부분 평지로 구성되어 있어 수많은 달림이들이
        기록갱신의 기회로
      </p>
      <p className="ms-5 ps-5">삼고있는 코스이기도 합니다.</p>
    </div>
  );
};
const HealthCourse = () => {
  return (
    <div>
      <h5 className="p-2">건강코스(5km)</h5>
      <p className="ms-4">대회일시: 2025.10.19.(일) 09:30 (집결 08:30)</p>
      <p className="ms-4">대청공원 ↔ 미호마을 ↔ 비상여수로 입구 ↔ 미호교</p>
      <p className="ms-4">
        코스 특징: 가족ㆍ이웃ㆍ친구ㆍ직장동료간 화합과 결속을 다질 수 있는
        왕복코스로써
      </p>
      <p className="ms-5 ps-5">
        초보달림이들의 마라톤입문의 계기가 되는 코스이기도 합니다.
      </p>
    </div>
  );
};
